<script>
export default {
  props: ['project'],
  emits: ['click'],
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<template>
  <!-- Clickable project card -->
  <div @click="handleClick"
    class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark transition-transform duration-200 hover:scale-[1.01]"
    role="button" tabindex="0">
    <div>
      <img :src="project.img" :alt="project.title" class="h-80 w-full object-cover rounded-t-xl border-none">
    </div>
    <div class="text-center px-4 py-6">
      <p class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
        {{ project.title }}
      </p>
      <span class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light">{{
        project.client }}</span>
    </div>
    <div class="flex flex-wrap gap-2 px-4 pb-6 justify-center">
      <span v-for="tag in project.tags" :key="tag"
          class="bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap">
          {{ tag }}
        </span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
